import { render, staticRenderFns } from "./CVideo.vue?vue&type=template&id=050bf4cf&scoped=true&"
import script from "./CVideo.vue?vue&type=script&lang=js&"
export * from "./CVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050bf4cf",
  null
  
)

export default component.exports